import { render, staticRenderFns } from "./BillingPaymentHistory.vue?vue&type=template&id=18353b7c"
import script from "./BillingPaymentHistory.vue?vue&type=script&lang=js"
export * from "./BillingPaymentHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports